// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__H-tkn","content":"Footer_content__aJpHx"};